module.exports = __webpack_public_path__ + "img/8.8b0ce65c.svg";